<template>
    <div class="bg-bluish">
        <!-- HERO -->
        <section class="relative min-h-screen overflow-hidden bg-[#050505] text-white">
            <div class="absolute inset-0">
                <div
                    class="h-full w-full bg-[url('@img/backgrounds/pattern-4.webp')] bg-cover bg-center"
                ></div>

                <div class="absolute inset-0 bg-black/70"></div>

                <div
                    class="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(255,196,0,0.16),transparent_28%),radial-gradient(circle_at_85%_18%,rgba(255,196,0,0.12),transparent_22%),radial-gradient(circle_at_bottom_right,rgba(255,255,255,0.04),transparent_26%)]"
                ></div>

                <div
                    class="absolute -left-24 top-24 h-[260px] w-[260px] rounded-full bg-baseColor/10 blur-3xl"
                ></div>
                <div
                    class="absolute right-[-80px] top-[-40px] h-[260px] w-[260px] rounded-full bg-baseColor/10 blur-3xl"
                ></div>

                <div class="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-[#0d141b] to-transparent"></div>
            </div>

            <div class="relative container flex min-h-screen flex-col justify-center pt-[90px] pb-[40px] md:pt-20">
                <div class="grid grid-cols-1 items-center gap-8 lg:grid-cols-12 lg:gap-10">
                    <!-- left -->
                    <div class="lg:col-span-7">
                        <Breadcrumbs theme="dark"/>

                        <div
                            class="mb-2 inline-flex items-center gap-3 rounded-full border border-white/10 bg-white/5 px-4 py-2"
                        >
                            <span class="h-2 w-2 rounded-full bg-baseColor shadow-[0_0_18px_rgba(255,196,0,0.8)]"></span>
                            <p class="text-xs font-semibold uppercase tracking-[0.14em] text-white/65">
                                Продвижение под ваш бизнес
                            </p>
                        </div>

                        <h1
                            class="max-w-4xl text-2xl font-extrabold leading-[1.04] tracking-[-0.04em] md:text-4xl"
                        >
                            Продвижение Авито
                            <span class="text-baseColor">для роста заявок</span>
                            и продаж
                        </h1>

                        <p
                            class="quote mt-6 max-w-3xl text-xs leading-[1.5] text-white/82 md:text-sm lg:text-[15px]"
                        >
                            Помогаем выстроить системное продвижение на Авито:
                            усиливаем выдачу, упаковываем объявления, повышаем
                            конверсию и подключаем аналитику, чтобы площадка
                            приносила реальных клиентов, а не просто просмотры.
                        </p>

                        <div class="mt-8 flex flex-col gap-3 sm:flex-row sm:flex-wrap">
                            <div
                                class="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-2 text-sm text-white/75"
                            >
                                <span class="h-1.5 w-1.5 rounded-full bg-baseColor"></span>
                                Упаковка объявлений
                            </div>

                            <div
                                class="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-2 text-sm text-white/75"
                            >
                                <span class="h-1.5 w-1.5 rounded-full bg-baseColor"></span>
                                Рост лидов и обращений
                            </div>

                            <div
                                class="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-2 text-sm text-white/75"
                            >
                                <span class="h-1.5 w-1.5 rounded-full bg-baseColor"></span>
                                Аналитика и CRM
                            </div>
                        </div>

                        <div class="mt-10 flex flex-col gap-4 sm:flex-row sm:items-center">
                            <div
                                @click.prevent="callbackStore.showBaseCallbackPopup({ title: 'Продвижение Авито', description: 'Продвижение Авито' })"
                                class="inline-flex h-[54px] w-full cursor-pointer items-center justify-center rounded-2xl bg-baseColor px-6 text-[16px] font-bold text-black shadow-[0_12px_40px_rgba(255,196,0,0.22)] transition hover:-translate-y-0.5 hover:bg-[#e6b000] sm:w-auto sm:min-w-[230px]"
                            >
                                Оставить заявку
                            </div>

                            <div class="flex items-center gap-3 text-sm text-white/55">
                                <span class="h-px w-10 bg-white/15"></span>
                                Разбор ниши и стратегии продвижения
                            </div>
                        </div>

                        <div class="mt-12 grid max-w-[820px] grid-cols-1 gap-4 max-md:hidden sm:grid-cols-3">
                            <div
                                v-for="(metric, index) in heroMetrics"
                                :key="metric.title"
                                class="group relative overflow-hidden rounded-[24px] border border-white/10 bg-white/[0.04] p-5 transition duration-300 hover:-translate-y-1 hover:border-baseColor/30 hover:bg-white/[0.06]"
                            >
                                <div
                                    class="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-baseColor/70 to-transparent"
                                ></div>

                                <div class="text-[34px] font-extrabold leading-none text-baseColor">
                                    {{ String(index + 1).padStart(2, '0') }}
                                </div>

                                <p class="mt-3 text-[15px] leading-[1.5] text-white/82">
                                    {{ metric.title }}
                                </p>
                            </div>
                        </div>
                    </div>

                    <!-- right -->
                    <div class="lg:col-span-5">
                        <div class="relative">
                            <div
                                class="absolute -inset-3 rounded-[34px] bg-gradient-to-br from-baseColor/15 via-transparent to-white/5 blur-2xl"
                            ></div>

                            <div
                                class="relative overflow-hidden rounded-[32px] border border-white/10 bg-white/[0.05] backdrop-blur-sm p-4"
                            >
                                <div
                                    class="mb-4 flex items-center justify-between rounded-[24px] border border-white/10 bg-black/20 px-4 py-3"
                                >
                                    <div>
                                        <div class="text-xs uppercase tracking-[0.14em] text-white/40">
                                            Канал продаж
                                        </div>
                                        <div class="mt-1 text-lg font-extrabold text-white">
                                            Авито под контролем
                                        </div>
                                    </div>

                                    <div
                                        class="inline-flex h-12 w-24 items-center justify-center rounded-2xl border border-white/10 bg-white"
                                    >
                                        <IconPartnerAvito class="h-12 w-24 px-2 py-1"/>
                                    </div>
                                </div>

                                <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-1">
                                    <div
                                        v-for="card in heroCards"
                                        :key="card.label"
                                        class="group relative overflow-hidden rounded-[26px] border border-white/10 bg-white/[0.04] p-6 transition duration-300 hover:border-baseColor/25 hover:bg-white/[0.06]"
                                    >
                                        <div
                                            class="absolute right-0 top-0 h-24 w-24 rounded-full bg-baseColor/10 blur-2xl transition duration-300 group-hover:bg-baseColor/15"
                                        ></div>

                                        <div class="relative">
                                            <div class="text-[11px] font-semibold uppercase tracking-[0.16em] text-white/42">
                                                {{ card.label }}
                                            </div>

                                            <div class="mt-3 text-[22px] font-extrabold leading-[1.2] text-white">
                                                {{ card.title }}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="mt-4 rounded-[26px] border border-white/10 bg-black/20 p-5">
                                    <div class="text-xs uppercase tracking-[0.14em] text-white/38">
                                        Результат
                                    </div>

                                    <div class="mt-2 text-xs leading-[1.5] text-white/72 md:text-sm">
                                        Система продвижения, где объявления, лиды, аналитика и обработка заявок
                                        работают как единый управляемый канал продаж.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- /right -->
                </div>
            </div>
        </section>

        <!-- ЧТО ДАЁТ -->
        <section class="relative overflow-hidden py-10 md:py-20">
            <div class="absolute inset-0 opacity-50">
                <img
                    src="@img/backgrounds/pattern-2.webp"
                    alt=""
                    class="h-full w-full object-cover"
                />
            </div>

            <div class="relative container">
                <p
                    class="mb-4 text-xs font-semibold uppercase tracking-[0.12em] text-[#7d8794] md:mb-3 md:text-sm"
                >
                    Системный подход к продвижению на площадке
                </p>

                <div class="mb-10 flex items-center gap-6 md:mb-14">
                    <h2
                        class="shrink-0 text-2xl font-extrabold uppercase leading-none tracking-[-0.04em] text-[#111111] md:text-4xl"
                    >
                        Что даёт продвижение на Авито
                    </h2>
                    <div class="hidden h-px w-full bg-[#c8d0d8] md:block"></div>
                </div>

                <div class="grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-3">
                    <div
                        v-for="item in benefits"
                        :key="item.title"
                        class="rounded-[28px] bg-white p-7 shadow-sm"
                    >
                        <div class="mb-6 flex items-center gap-4">
                            <div class="flex h-[40px] w-[40px] items-center justify-center rounded-full bg-bluish">
                                <span class="block h-3.5 w-3.5 rounded-full bg-baseColor"></span>
                            </div>

                            <h3 class="text-[22px] font-extrabold leading-[1.25] text-[#173047]">
                                {{ item.title }}
                            </h3>
                        </div>

                        <p class="text-sm leading-[1.5] text-[#587086] md:text-[15px]">
                            {{ item.text }}
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <!-- ПРЕИМУЩЕСТВА -->
        <section class="py-10 md:pb-20">
            <div class="container">
                <div class="mb-10 flex items-center gap-6 md:mb-14">
                    <h2
                        class="shrink-0 text-2xl font-extrabold uppercase leading-none tracking-[-0.04em] text-[#111111] md:text-4xl"
                    >
                        Наши преимущества
                    </h2>
                    <div class="hidden h-px w-full bg-[#c8d0d8] md:block"></div>
                </div>

                <div class="grid grid-cols-1 gap-5 lg:grid-cols-3">
                    <div
                        v-for="(item, index) in advantages"
                        :key="item.title"
                        class="rounded-[28px] bg-center bg-no-repeat p-7 shadow-sm"
                        style="background-image: url('@img/backgrounds/pattern-2.webp'); background-color: white;"
                    >
                        <div class="mb-5 flex items-center gap-4">
                            <div
                                class="flex h-[58px] min-w-[58px] items-center justify-center rounded-full bg-baseColor text-2xl font-extrabold text-black"
                            >
                                {{ String(index + 1).padStart(2, '0') }}
                            </div>

                            <h3 class="pt-1 text-base font-extrabold leading-[1.35] text-[#20262d] md:text-lg">
                                {{ item.title }}
                            </h3>
                        </div>

                        <p class="text-sm leading-[1.5] text-[#6b7d8e] md:text-[15px]">
                            {{ item.text }}
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <!-- ЧТО ВХОДИТ -->
        <section class="py-10 md:pb-20">
            <div class="container">
                <p
                    class="mb-4 text-xs font-semibold uppercase tracking-[0.12em] text-[#7d8794] md:mb-3 md:text-sm"
                >
                    Упаковка, продвижение и аналитика
                </p>

                <div class="mb-10 flex items-center gap-6 md:mb-14">
                    <h2
                        class="text-2xl font-extrabold uppercase leading-none tracking-[-0.04em] text-[#111111] md:text-4xl"
                    >
                        Что входит в услугу
                    </h2>
                </div>

                <div class="grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-3">
                    <div
                        v-for="item in included"
                        :key="item.title"
                        class="rounded-[28px] bg-white p-7 shadow-sm"
                    >
                        <div class="mb-6 flex items-center gap-4">
                            <div class="flex h-[40px] w-[40px] items-center justify-center rounded-full bg-bluish">
                                <span class="block h-3.5 w-3.5 rounded-full bg-baseColor"></span>
                            </div>

                            <h3 class="text-[22px] font-extrabold leading-[1.25] text-[#173047]">
                                {{ item.title }}
                            </h3>
                        </div>

                        <p class="text-sm leading-[1.5] text-[#587086] md:text-[15px]">
                            {{ item.text }}
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <!-- ЭТАПЫ -->
        <section class="bg-white py-10 md:py-20">
            <div class="container">
                <div class="mb-10 flex items-center gap-6 md:mb-14">
                    <h2
                        class="shrink-0 text-2xl font-extrabold uppercase leading-none tracking-[-0.04em] text-[#111111] md:text-4xl"
                    >
                        Как проходит работа
                    </h2>
                    <div class="hidden h-px w-full bg-[#c8d0d8] md:block"></div>
                </div>

                <div class="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-5">
                    <div
                        v-for="(step, index) in steps"
                        :key="step.title"
                        class="group relative flex h-full flex-col overflow-hidden rounded-3xl border border-[#dfe6ec] bg-white p-6 shadow-sm transition duration-300 hover:-translate-y-1 hover:border-baseColor/30 hover:shadow-md"
                    >
                        <div class="absolute inset-x-0 top-0 h-1 bg-baseColor/90"></div>

                        <div
                            class="absolute right-0 top-0 h-24 w-24 rounded-full bg-baseColor/10 blur-2xl transition duration-300 group-hover:bg-baseColor/15"
                        ></div>

                        <div class="relative">
                            <div
                                class="inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-baseColor/10 text-2xl font-extrabold leading-none tracking-tight text-baseColor"
                            >
                                {{ String(index + 1).padStart(2, '0') }}
                            </div>
                        </div>

                        <h3 class="relative mt-5 text-lg font-extrabold leading-tight text-[#172f45] md:text-xl">
                            {{ step.title }}
                        </h3>

                        <p class="relative mt-3 text-sm leading-[1.5] text-[#63788b]">
                            {{ step.text }}
                        </p>

                        <div class="mt-auto flex items-center gap-2 pt-4">
                            <div class="h-1.5 w-1.5 rounded-full bg-baseColor"></div>
                            <div class="h-px flex-1 bg-[#e3e8ee]"></div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- ЗАДАЧИ -->
        <section class="py-10 md:pb-20">
            <div class="container">
                <p
                    class="mb-4 text-xs font-semibold uppercase tracking-[0.12em] text-[#7d8794] md:mb-3 md:text-sm"
                >
                    Типовые проблемы, которые мы закрываем
                </p>

                <div class="mb-10 flex items-center gap-6 md:mb-14">
                    <h2
                        class="text-2xl font-extrabold uppercase leading-none tracking-[-0.04em] text-[#111111] md:text-4xl"
                    >
                        Какие задачи решаем
                    </h2>
                </div>

                <div class="grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-3">
                    <div
                        v-for="item in problems"
                        :key="item"
                        class="rounded-[28px] bg-white p-7 shadow-sm"
                    >
                        <div class="mb-6 flex items-center gap-4">
                            <div class="flex h-[40px] w-[40px] items-center justify-center rounded-full bg-bluish">
                                <span class="block h-3.5 w-3.5 rounded-full bg-baseColor"></span>
                            </div>

                            <h3 class="text-[22px] font-extrabold leading-[1.25] text-[#173047]">
                                Задача бизнеса
                            </h3>
                        </div>

                        <p class="text-sm leading-[1.5] text-[#587086] md:text-[15px]">
                            {{ item }}
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <!-- CTA -->
        <section class="bg-white py-10 md:pb-20">
            <div class="container">
                <div
                    class="relative overflow-hidden rounded-3xl bg-bluish bg-[url('@img/backgrounds/pattern-2.webp')] bg-cover bg-center bg-no-repeat shadow-xl"
                >
                    <div
                        class="relative grid grid-cols-1 gap-8 px-6 py-8 md:px-10 md:py-10 lg:grid-cols-[minmax(0,1.4fr)_auto] lg:items-center lg:gap-10 xl:px-12"
                    >
                        <div class="max-w-3xl">
                            <h2 class="text-2xl font-extrabold leading-tight tracking-tight text-[#173047] md:text-3xl lg:text-4xl">
                                Готовы усилить продажи через Авито?
                            </h2>

                            <p class="mt-4 max-w-2xl text-sm leading-[1.5] text-[#5f7385] md:text-base">
                                Бесплатно разберём вашу нишу, объявления, конкурентов и текущую стратегию
                                продвижения, а затем предложим понятный план действий для роста обращений и продаж.
                            </p>
                        </div>

                        <div class="flex lg:justify-end">
                            <button
                                @click.prevent="callbackStore.showBaseCallbackPopup({ title: 'Продвижение Авито', description: 'Продвижение Авито' })"
                                class="inline-flex h-14 w-full items-center justify-center rounded-2xl bg-baseColor px-6 text-sm font-bold uppercase tracking-wide text-black shadow-md transition hover:bg-baseColor/80 hover:shadow-lg sm:w-auto sm:min-w-72"
                            >
                                Оставить заявку
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script setup>
import { useCallbackStore } from "@js/store/CallbackStore.js";
import IconPartnerAvito from "@js/components/Icons/IconPartnerAvito.vue";
import Breadcrumbs from "@js/components/Breadcrumbs/Breadcrumbs.vue";

const callbackStore = useCallbackStore();

const heroMetrics = [
    {
        title: "Увеличивайте поток целевых обращений",
    },
    {
        title: "Повышайте видимость объявлений в выдаче",
    },
    {
        title: "Улучшайте конверсию в заявки и продажи",
    },
];

const heroCards = [
    {
        label: "Упаковка",
        title: "Заголовки, фото, описания и структура объявлений",
    },
    {
        label: "Продвижение",
        title: "Рост просмотров, контактов и входящих заявок",
    },
    {
        label: "Контроль",
        title: "Аналитика, обработка лидов и интеграция с CRM",
    },
];

const benefits = [
    {
        title: "Больше заявок",
        text: "Продуманная упаковка и системное продвижение повышают видимость объявлений и дают стабильный поток входящих обращений.",
    },
    {
        title: "Выше конверсия",
        text: "Корректные заголовки, фото, описания и структура карточек помогают быстрее переводить просмотры в звонки и сообщения.",
    },
    {
        title: "Понятная аналитика",
        text: "Вы видите, какие объявления работают лучше, откуда приходят клиенты и какие действия реально влияют на результат.",
    },
    {
        title: "Меньше хаоса",
        text: "Помогаем выстроить понятную систему размещения, обновления и обработки объявлений без ручной путаницы и потерь.",
    },
    {
        title: "Контроль лидов",
        text: "При необходимости подключаем CRM и объединяем входящие обращения, чтобы менеджеры не теряли клиентов и быстрее их обрабатывали.",
    },
    {
        title: "Рост продаж",
        text: "Фокусируемся не на просмотрах, а на результате: количестве обращений, стоимости лида и итоговой эффективности канала.",
    },
];

const advantages = [
    {
        title: "Смотрим на Авито как на систему продаж",
        text: "Не ограничиваемся публикацией объявлений. Выстраиваем структуру продвижения, упаковку и контроль заявок как полноценный канал продаж.",
    },
    {
        title: "Работаем с упаковкой и конверсией",
        text: "Подбираем правильные формулировки, усиливаем заголовки, фотографии и описания, чтобы объявления лучше работали на аудиторию и выдачу.",
    },
    {
        title: "Ориентируемся на результат бизнеса",
        text: "Оцениваем не только охваты, но и стоимость обращения, качество лидов, конверсию в продажу и общую эффективность продвижения.",
    },
];

const included = [
    {
        title: "Аудит ниши и конкурентов",
        text: "Изучаем рынок, конкурентов, текущие объявления и подход к продвижению, чтобы найти реальные точки роста.",
    },
    {
        title: "Упаковка объявлений",
        text: "Прорабатываем заголовки, описания, фотографии, ключевые преимущества и структуру карточек для усиления конверсии.",
    },
    {
        title: "Стратегия размещения",
        text: "Формируем подход к публикациям, регионам, категориям, сегментации и логике обновления объявлений.",
    },
    {
        title: "Продвижение и тестирование",
        text: "Запускаем продвижение, тестируем гипотезы, отслеживаем изменения в выдаче и корректируем стратегию по данным.",
    },
    {
        title: "Аналитика обращений",
        text: "Считаем отклики, звонки, сообщения и качество лидов, чтобы понимать, какие объявления работают лучше всего.",
    },
    {
        title: "Интеграция с CRM",
        text: "Если нужно, связываем Авито с CRM и другими сервисами, чтобы обращения фиксировались и обрабатывались без потерь.",
    },
];

const steps = [
    {
        title: "Анализ бизнеса и категории",
        text: "Разбираем продукт, целевую аудиторию, конкурентов и текущую ситуацию на площадке, чтобы определить реальные точки роста.",
    },
    {
        title: "Подготовка стратегии",
        text: "Формируем структуру размещения, подход к продвижению, сегментацию объявлений и общий сценарий работы с каналом.",
    },
    {
        title: "Упаковка объявлений",
        text: "Усиливаем заголовки, описания, визуал и ключевые смыслы, чтобы повысить видимость и конверсию в обращение.",
    },
    {
        title: "Запуск и оптимизация",
        text: "Запускаем продвижение, наблюдаем за динамикой, тестируем гипотезы и корректируем стратегию по результатам.",
    },
    {
        title: "Контроль и масштабирование",
        text: "Считаем эффективность, подключаем аналитику и выстраиваем понятную систему роста заявок и продаж через Авито.",
    },
];

const problems = [
    "Объявления не дают стабильного потока заявок.",
    "Есть просмотры, но слишком мало звонков и сообщений.",
    "Неясно, какие объявления работают, а какие только расходуют бюджет.",
    "Карточки оформлены слабо и проигрывают конкурентам в выдаче.",
    "Менеджеры обрабатывают обращения без системы, из-за чего теряются клиенты.",
    "Нет прозрачной аналитики по стоимости лида и эффективности канала.",
];
</script>
